import React from 'react';

interface ApartmentIconProps {
  size?: number;
  color?: string;
  className?: string;
}

export const ApartmentIcon: React.FC<ApartmentIconProps> = ({ 
  size = 32, 
  color = '#4D4D4D',
  className 
}) => {
  return (
    <svg 
      width={size} 
      height={size} 
      viewBox="0 0 32 32" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path 
        d="M26.6654 26.6654V8.66536H18.6654V5.33203H13.332V8.66536H5.33203V26.6654M26.6654 26.6654H5.33203M26.6654 26.6654H28.6654M5.33203 26.6654H3.33203M9.33203 12.0013H12.6654M9.33203 15.9987H12.6654M9.33203 19.9961H12.6654M9.33203 23.9935H12.6654M19.332 12.0013H22.6654M19.332 15.9987H22.6654M19.332 19.9961H22.6654" 
        stroke={color} 
        strokeWidth="2" 
        strokeLinecap="round" 
        strokeLinejoin="round"
      />
    </svg>
  );
};
